import memoize from 'lodash/memoize';

import FeatureGates from '@atlaskit/feature-gate-js-client';
import { fg } from '@atlaskit/platform-feature-flags';
import { STATSIG_ROVO_SEARCH_QF_EXPERIENCE_LAYER } from '@atlassian/search-experiment';

import {
	hasSAINHelloLayerParamValue,
	hasSAINLayerParamValue,
} from './get-sain-layer-frontend-experiment';

const isLuminaEnabledUnmemoized = (): boolean => {
	if (fg('kd_dynamic_layout_in_sain')) {
		return true;
	}

	return (
		hasSAINHelloLayerParamValue('LuminaInSAIN', 'test') ||
		hasSAINLayerParamValue('LuminaInSAIN', 'test')
	);
};

const isSourcesInShortSAINAnswersEnabledUnmemoized = () => {
	if (fg('kd_sain_show_sources_in_short_answers')) {
		return true;
	}

	return hasSAINLayerParamValue('sourcesInShortSAINAnswers', 'test');
};

const isThirdPartyBannerEnabledUnmemoized = () => {
	if (fg('rovo_search_3p_banner_opt_out') || SAINFeatureControl.isLuminaEnabled()) {
		return false;
	}
	if (fg('kd_sain_show_third_party_banner')) {
		return true;
	}

	return (
		hasSAINLayerParamValue('SAINThirdPartyBanner', 'test') ||
		hasSAINHelloLayerParamValue('SAINThirdPartyBanner', 'test')
	);
};

const isZeroQuerySuggestionsV1HelloEnabledUnmemoized = () => {
	const layer = FeatureGates.getLayer(STATSIG_ROVO_SEARCH_QF_EXPERIENCE_LAYER);
	return layer.get<boolean>('isZeroQuerySuggestionsV1HelloEnabled', false);
};

export const SAINFeatureControl = {
	isLuminaEnabled: memoize(isLuminaEnabledUnmemoized),
	isSourcesInShortSAINAnswersEnabled: memoize(isSourcesInShortSAINAnswersEnabledUnmemoized),
	isThirdPartyBannerEnabled: memoize(isThirdPartyBannerEnabledUnmemoized),
	isZeroQuerySuggestionsV1HelloEnabled: memoize(isZeroQuerySuggestionsV1HelloEnabledUnmemoized),
};
